<template>
    <div id="editAddress">
        <div class="nav"><img src="../assets/img/箭头 (3).png" alt class="back" @click="goback" /> 新建收获地址 <span v-if="address_id==undefined?false:true" class="del" @click="dele">删除</span> </div>
        <div class="containar">
            <div class="add">
               <div class="userN"> 
                   <input type="text" placeholder="请输入收货人姓名" v-model="consignee">
                </div>
                <div class="userM">
                    <input type="text" placeholder="请输入收货手机号码" v-model="mobile">
                </div>
                <div class="userPro">
                    <span>省份</span>
                    <select class="public-choice" v-model="provinceId" autocomplete="off"  @change="getCity(provinceId)">
                        <option v-if="pro" :value="provinceId" disabled selected>{{province_name}}</option>
                        <option v-else :value="item.id" v-for="item in provinceList" :key="item.id">{{item.name}}</option>
                    </select>
                </div>
                <div class="userPro">
                    <span>城市</span>
                    <select class="public-choice" v-model="cityId" autocomplete="off"  @change="getArea(cityId)" >
                        <option v-if="city" :value="cityId" disabled selected>{{city_name}}</option>
                        <option v-else :value="item.id" v-for="item in cityList" :key="item.id">{{item.name}}</option>
                    </select>
                </div>
                <div class="userPro">
                    <span>县/区</span>
                    <select class="public-choice" v-model="countryId" autocomplete="off" >
                        <option v-if="area" :value="countryId" disabled selected>{{district_name}}</option>
                        <option v-else :value="item.id" v-for="item in countryList" :key="item.id">{{item.name}}</option>
                    </select>
                </div>
                <textarea name="" id="" cols="30" rows="10" placeholder="详细地址" v-model="address"></textarea>
                <div class="default">
                    设置为默认地址
                    <van-switch v-model="checked" active-color="#FE0D07" inactive-color="#ccc" class="btn" />
                </div>
            </div>
            <div class="save" @click="conserve">保存</div>
        </div>
    </div>
</template>
<script>
import qs from "qs";
import {getAddress,editAddress,delAddress} from '@/api'
export default {
    data(){
        return{
            token:'',
            consignee:'',    //收货人姓名
            address:'',      //收货人详细地址
            mobile:'',       //收货人手机号
            provinceId:'',   //选中省份id
            provinceList:[], //全部省份列表
            cityId:'',       //选中的城市id
            cityList:[],     //所选省份的所有城市id
            countryId:'',    //选中的区县id
            countryList:[],  //所选城市的所有区县id
            checked: false,  //是否为默认地址
            address_id:'',   //原地址id
            detailinfo:'',   //原地址详细信息
            is_default:'',   //是否为默认地址
            province_name:'',
            city_name:'',
            district_name:'',
            pro:true,
            city:true,
            area:true
        }
    },
    created(){
       this.getPro()
       this.getUserInfo()
       this.token = window.localStorage.getItem('token')
    },
    methods:{
        // 返回按钮
        goback(){
            this.$router.go(-1)
        },
        // 获取用户要编辑的地址信息
        getUserInfo(){
            this.detailinfo= this.$route.query.detailinfo;
            if(this.detailinfo!==''){
                this.consignee = this.detailinfo.consignee
                this.mobile = this.detailinfo.mobile
                this.address = this.detailinfo.address
                this.provinceId = this.detailinfo.province
                this.cityId = this.detailinfo.city
                this.countryId = this.detailinfo.district
                this.address_id = this.detailinfo.address_id
                this.province_name = this.detailinfo.province_name
                this.city_name = this.detailinfo.city_name
                this.district_name = this.detailinfo.district_name
                if(this.detailinfo.is_default===1){
                    this.checked=true
                }
            }
        },
        // 获取所有省份
        async getPro(){
            let params = {
            parent_id:0
            }
            let res = await getAddress(params)
            if(res.status===1){
                this.pro=false
                this.provinceList = res.result
            }else{
                this.$toast({message:res.msg,duration:'2000'}) 
            }
        },
        // 获取城市
        async getCity(provinceId){
            let params = {
                parent_id:provinceId
            }
            let res  = await getAddress(params)
            if(res.status===1){
                this.city = false
                this.cityList = res.result
            }else{
                this.$toast({message:res.msg,duration:'2000'}) 
            }
        },
        // 获取区县
        async getArea(cityId){
            let params = {
                parent_id:cityId
            }
            let res = await getAddress(params)
            
            if(res.status===1){
                this.area = false
                this.countryList = res.result
            }else{
                this.$toast({message:res.msg,duration:'2000'}) 
            }
        },
        // 删除地址
        async dele(){
            let params = {
                token:this.token,
                id:this.address_id
            }
            let res = await delAddress(qs.stringify(params))
            if(res.status==1){
                this.$toast({message:res.msg,duration:'2000'}) 
                this.$router.go(-1)
            }else if(res.status==-101){
                window.localStorage.removeItem("token");
                this.$router.push('/')
            }else{
                this.$toast({message:res.msg,duration:'2000'}) 
            }
            
        },
        // 点击保存编辑/添加新地址
        async conserve(){
            if(this.checked===false){
                this.is_default = 0
            }else if(this.checked===true){
                this.is_default = 1
            }
            let params={
                province:this.provinceId,
                city:this.cityId,
                district:this.countryId,
                consignee:this.consignee,
                address:this.address,
                mobile:this.mobile,
                is_default:this.is_default,
                token:this.token,
                address_id:this.address_id
            }
            let res = await editAddress(qs.stringify(params))
            if(res.status===1){
                this.$toast({message:res.msg,duration:'2000'}) 
                this.$router.go(-1)
            }else if(res.status===-101){
                window.localStorage.removeItem("token");
                this.$router.push('/')
            }else{
                this.$toast({message:res.msg,duration:'2000'}) 
            }
        }
    }
}
</script>
<style lang="less" scoped>
#editAddress{
    width: 750px;
    height: 100vh;
    position: relative;
    font-size: 16PX;
    .nav {
        width: 750px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        font-size: 26px;
        color: #000000;
        background-color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;
        .back {
            width: 15px;
            height: 27px;
            float: left;
            margin-top: 30px;
            margin-left: 31px;
        }
        .del{
            position: absolute;
            right: 20px;
            top: 5px;
            color: #757575;

        }
    }
    .containar{
        position: relative;
        height: 100vh;
        width: 100%;
        padding: 100px 0 20px 0;
        box-sizing: border-box;
        background-color: #f6f6f6;
        .add{
            background-color:#fff ;
            input{
                display: block;
                width: 100%;
                padding: 5px 20px;
                height: 80px;
                background:none;  
                outline:none;  
                border:none;
            }
            input:focus{   
                border:none;
            }
            textarea{
                width: 90%;
                height: 100px;
                border: none;
                padding: 20px;
                resize: none;
            }
            .userN{
                border-bottom: 1px solid #ccc;
                padding-bottom: 5px;
            }
            .userM{
                border-bottom: 1px solid #ccc;
                padding-bottom: 5px;
            }
        }
        .userPro{
            padding: 20px;
            border-bottom: 1px solid #ccc;
            select{
                font-size: 16PX;
                padding-left: 10px;
                width: 500px;
                border: none;
                outline: none;
                -moz-appearance: none;
                -webkit-appearance: none;
                -webkit-tap-highlight-color: rgba(0,0,0,0);
                option{
                    border: none;
                    outline: none;
                    border: none;
                }
            }
        }
        .default{
            height: 120px;
            line-height: 120px;
            width: 100%;
            border-top: 5px solid #f6f6f6;
            position: relative;
            padding: 0 20px;
            box-sizing: border-box;
            .btn{
                position: absolute;
                top: 20px;
                right: 20px;
            }

        }
        .save{
            width: 80%;
            height: 100px;
            line-height: 100px;
            text-align: center;
            border-radius: 50px;
            background-color: #fe0d07;
            margin: 30px auto;
            color: white;
        }
    }
}
</style>